import { RouteRecordRaw } from 'vue-router';
import { route } from '@/router/utils'
// import { allPermissions } from '@access/index'
// import { accessPermission } from '@/permissions/permissions'

// const {
//   STAFF: {
//     USER: {
//       VIEW
//     },
//   },
// } = allPermissions

const list = () => import('./List.vue')
const details = () => import('./details/Details.vue')

export const REGISTRATIONS_LIST_PAGE_NAME = 'cabinet:registrations'
export const REGISTRATION_DETAILS_PAGE_NAME = 'cabinet:registration-details'
export const REGISTRATION_UPDATE_PAGE_NAME = 'cabinet:registration-update'

// URLs
export const REGISTRATIONS_LIST_PAGE_URL = ''
export const REGISTRATION_DETAILS_PAGE_URL = 'details/:id?/'
export const REGISTRATION_UPDATE_PAGE_URL = 'update/:id?/'


export function createRoutes(options): RouteRecordRaw[] {
  return [
    route(REGISTRATIONS_LIST_PAGE_URL, list, REGISTRATIONS_LIST_PAGE_NAME, {
      meta: {
        breadcrumb: 'registrations',
        // ...accessPermission([VIEW], options),
      }
    }),
    route(REGISTRATION_DETAILS_PAGE_URL, details, REGISTRATION_DETAILS_PAGE_NAME, {
      meta: {
        breadcrumb: 'registration',
        parent: REGISTRATIONS_LIST_PAGE_NAME,
        // ...accessPermission([VIEW], options),
      }
    }),
    route(REGISTRATION_UPDATE_PAGE_URL, details, REGISTRATION_UPDATE_PAGE_NAME, {
      meta: {
        breadcrumb: 'registration-update',
        parent: REGISTRATIONS_LIST_PAGE_NAME,
        isUpdate: true,
        isNew: false,
        // ...accessPermission([VIEW], options),
      }
    }),
  ]
}
